<template>
  <div class="container">
    <moduleTitle title="笔试信息"></moduleTitle>
    <div class="table">
      <div class="row">
        <div class="column">应聘部门</div>
        <div class="column">{{ item.ypdwhbm }}</div>
      </div>
      <div class="row">
        <div class="column">应聘岗位</div>
        <div class="column">{{ item.ypgw }}</div>
      </div>
      <div class="row">
        <div class="column">审核结果</div>
        <div class="column">
          <div :class="[item.shjg == '1' ? 'success' : 'danger']">
            {{ item.shjg == "1" ? "通过" : "不通过" }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column">审核意见</div>
        <div class="column">{{ item.shyj }}</div>
      </div>
      <div class="row">
        <div class="column">笔试通知</div>
        <div class="column" @click="toMsg">
          <div class="link">查看笔试通知</div>
        </div>
      </div>
      <div class="row">
        <div class="column">是否确认参加笔试</div>
        <div class="column">
          <div>{{ item.sfqrcjbs == "1" ? "是" : "否" }}</div>
        </div>
      </div>
      <div class="row">
        <div class="column">笔试成绩</div>
        <div class="column">
          <div>{{ item.bscj }}</div>
        </div>
      </div>
      <div class="row">
        <div class="column">作文成绩</div>
        <div class="column">
          <div>{{ item.zwcj }}</div>
        </div>
      </div>
      <div class="row">
        <div class="column">笔试结果</div>
        <div class="column">
          <div :class="[item.bsjg == '1' ? 'success' : 'danger']">
            {{ item.bsjg == "1" ? "通过" : "不通过" }}
          </div>
        </div>
      </div>
    </div>
    <div class="footer-btn">
      <el-button
        v-if="item.sfqrcjms !== '1' && item.bsjg == '1'"
        @click="confirmInterview"
        type="primary"
        size="small"
        >确认参加面试</el-button
      >
      <el-button type="primary" size="small" @click="close">关闭</el-button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.success {
  color: #27c18c;
}
.danger {
  color: #ff5858;
}
.link {
  color: #2a8ae0;
  &:hover {
    cursor: pointer;
  }
}
.container {
  width: 80%;
  margin: 40px auto;
  .table {
    width: 80%;
    margin: auto;
    .row {
      border: 1px solid #dcdcdc;
      border-top: 0px;
      display: flex;
      &:first-child {
        border-top: 1px solid #dcdcdc;
      }
      .column {
        padding: 20px;
        text-align: center;
        width: 50%;
        &:first-child {
          border-right: 1px solid #dcdcdc;
          font-weight: bold;
        }
      }
    }
  }
  .footer-btn {
    display: flex;
    justify-content: center;
    padding: 20px;
  }
}
</style>
<script>
import moduleTitle from "@/components/moduleTitle.vue";
import request from "@/api/jobProgress.js";
export default {
  components: {
    moduleTitle
  },
  data() {
    return {
      item: {}
    };
  },
  mounted() {
    this.item = JSON.parse(this.$route.params.data);
  },
  methods: {
    close() {
      this.$router.push({ name: "JobProgress" });
    },
    /* 查询笔试通知 */
    toMsg() {
      this.$router.push({
        path: "/msg",
        query: {
          id: this.item.zphdid
        }
      });
    },
    /* 确认参加笔试 */
    async confirmInterview() {
      const para = {
        zphdbmid: this.item.zphdbmid
      };
      await request.confirmInterview(para);
      this.$message({
        type: "success",
        message: "确认成功"
      });
      this.close();
    }
  }
};
</script>
